module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/24-af11be8719edf1eaaf95d913607aaf35.jpg";